import { Component, OnInit, Input, QueryList, ViewChildren, OnDestroy } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { FormTextInputComponent } from '../form-text-input/form-text-input.component';
import { FormTextAreaComponent } from '../form-text-area/form-text-area.component';
import { FormDropdownComponent } from '../form-dropdown/form-dropdown.component';
import { ApiService } from '../../services/ApiService';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { JssContextService } from '../../jss-context.service';
import { RestService } from '../../services/RestService';
@Component({
  selector: 'app-complaint-form',
  templateUrl: './complaint-form.component.html',
  styleUrls: ['./complaint-form.component.scss']
})
export class ComplaintFormComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  salutationOptions: any[] = [];
  statusOptions: any[] = [];
  isCustomerOptions: any[] = [];
  howToContactOptions: any[] = [];
  loading:boolean;
  submissionResponse: string ="";

  private reCaptchaSubscription: Subscription;

  @ViewChildren(FormTextInputComponent)
  formTextInputComponents: QueryList<FormTextInputComponent>;
  @ViewChildren(FormTextAreaComponent)
  formTextAreaComponents: QueryList<FormTextAreaComponent>;
  @ViewChildren(FormDropdownComponent)
  formDropdownComponents: QueryList<FormDropdownComponent>;
  warningFlag: boolean = false;
  // public maskNumber: {} = { mask : /^\d*$/ };
  complaintForm: any;
  contextSubscription:any;
  language:string;
  currentRoute:string;

  constructor(jssStylingService: JssStylingService, protected apiService: ApiService, private recaptchaV3Service: ReCaptchaV3Service, private jssContext: JssContextService, private RestService: RestService) { 
    this.jssStylingService = jssStylingService;
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('ComplaintForm component initialized with component data', this.rendering);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language;
      this.currentRoute = newState.serverRoute;
    });
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.initializeForm();
    this.createDropdowns();
    
  }

  initializeForm():void {
    this.complaintForm = new FormGroup({
      salutation: new FormControl('', [
        Validators.required,
      ]),
      wayofcontact: new FormControl('', [
        Validators.required,
      ]),
      name: new FormControl('', [
        Validators.required, 
        Validators.minLength(3),
        Validators.maxLength(30),
        this.alphabeticValidator()
      ]),
      surname: new FormControl('', [
        Validators.required, 
        Validators.minLength(3),
        Validators.maxLength(30),
        this.alphabeticValidator()
      ]),
      oasis: new FormControl('', [
        Validators.required, 
        Validators.minLength(3),
        Validators.maxLength(30)
      ]),
      topic: new FormControl('', [
        Validators.required, 
        Validators.minLength(3),
        Validators.maxLength(50),
        this.alphabeticValidator()
      ]),
      status: new FormControl('', [
        Validators.required,
      ]),
      isCustomer: new FormControl('', [
        Validators.required,
      ]),
      email: new FormControl('', [
        Validators.required, 
        Validators.email
      ]),
      telephone: new FormControl('',[
        Validators.required
      ]),
      timeslot: new FormControl('',[
        Validators.required
      ]),
      message: new FormControl('',[
        Validators.required,
        this.textAreaValidator(),
      ]),
      termsCheckbox: new FormControl('', [
        Validators.required
      ]),
    });
      
    this.complaintForm.get('oasis')?.disable();
    this.complaintForm.get('email')?.disable();
    this.complaintForm.get('telephone')?.disable();
    this.complaintForm.get('timeslot')?.disable();

  }

  createDropdowns():void{
    (this.rendering.fields?.SalutationOptions as any)?.forEach((item: any) => {
      let salutationOption = {
        text: item.fields?.Text?.value,
        value: item.fields?.Value?.value,
      };
      this.salutationOptions.push(salutationOption);
    });
    
    (this.rendering.fields?.StatusOptions as any)?.forEach((item: any) => {
      let statusOption = {
        text: item.fields?.Text?.value,
        value: item.fields?.Value?.value,
      };
      this.statusOptions.push(statusOption);
    });
    
    (this.rendering.fields?.IsCustomerOptions as any)?.forEach((item: any) => {
      let isCustomerOption = {
        text: item.fields?.Text?.value,
        value: item.fields?.Value?.value,
      };
      this.isCustomerOptions.push(isCustomerOption);
    });
    
    (this.rendering.fields?.HowToContactOptions as any)?.forEach((item: any) => {
      let howToContactOption = {
        text: item.fields?.Text?.value,
        value: item.fields?.Value?.value,
      };
      this.howToContactOptions.push(howToContactOption);
    });
  }

  alphabeticValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        // If the field is empty, validation passes (no error)
        return null;
      }
      const valid = /^[\p{L}\s]+$/u.test(control.value);  // Allow only alphabets and spaces
      return valid ? null : { alphabeticOnly: true };
    };
  }

  isFieldInvalid(field: string): boolean {
    return this.complaintForm.get(field)?.touched && this.complaintForm.get(field)?.invalid;
  }

  changeTimeslot(index:number){
    this.complaintForm.get('timeslot').setValue(((this.rendering?.fields?.WhenToContactOptions as [])[index] as any)?.fields?.Value?.value);
    // debugger;
  }

  textAreaValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        // If the field is empty, validation passes (no error)
        return null;
      }
      const valid = /^[\p{L}\p{N}\s.,!?'"()\-:;@#&]+$/u.test(control.value);  // Allow only alphabets and spaces
      return valid ? null : { alphabeticOnly: true };
    };
  }
  
  changeIsCustomer(){
    if(this.complaintForm.get('isCustomer')?.value == '0'){
       this.complaintForm.get('oasis')?.enable();
    }else{
      this.complaintForm.get('oasis')?.disable();
      this.complaintForm.get('oasis')?.setValue('');

    }
    // debugger;
  }

  changeContactWay(){
    if(this.complaintForm.get('wayofcontact')?.value.toLowerCase() == 'email'){
       this.complaintForm.get('email')?.enable();
      this.complaintForm.get('telephone')?.disable();
      this.complaintForm.get('telephone')?.setValue('');
      this.complaintForm.get('timeslot')?.disable();
      this.complaintForm.get('timeslot')?.setValue('');
    }else{
      this.complaintForm.get('telephone')?.enable();
      this.complaintForm.get('timeslot')?.enable();
      this.complaintForm.get('email')?.disable();
      this.complaintForm.get('email')?.setValue('');
    }
    // debugger;
  }

  clearForm() {
    this.formDropdownComponents.forEach(component => {
      component.reset(component.id);
    });

    // this.complaintForm.clearValidators();
    this.initializeForm();
  }

  onSubmit() {
    // options[options.FindIndex(option => option.value == value)].text
    this.complaintForm.updateValueAndValidity();
    console.log(this.complaintForm.value);
    if (this.complaintForm.invalid) {
      this.complaintForm.markAllAsTouched();  // This will mark all controls as touched
    }
  
    if (this.complaintForm.valid) {
      this.loading= true;
      this.reCaptchaSubscription = this.recaptchaV3Service.execute('formSubmission').subscribe(
        (token) => {

          this.RestService.validateToken(token).subscribe({
            next: (respRecaptcha: any) => {
              // If recaptcha is valid
              if(respRecaptcha.success){
                var request = {
                  salutation: this.complaintForm.get('salutation')?.value,
                  nameTo: this.complaintForm.get('name')?.value,
                  surname: this.complaintForm.get('surname')?.value,
                  emailTo: (this.rendering?.fields?.EmailTo as any).value,
                  email: this.complaintForm.get('email')?.value,
                  isCustomer: this.complaintForm.get('isCustomer')?.value === "0",
                  oasisCode: this.complaintForm.get('oasis')?.value,
                  status: this.complaintForm.get('status')?.value,
                  topic: this.complaintForm.get('topic')?.value,
                  message: this.complaintForm.get('message')?.value,
                  telephone: this.complaintForm.get('telephone').value,
                  subject:"complaint form"
                };
                
                const json = JSON.stringify(request);
                const base64 = btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=+$/, '');
                const action = `/sitecore/api/layout/render/jss?item=${this.currentRoute.replace(/\//g, "%2F")}%2F&sc_lang=${this.language}&sc_apikey={40D54338-B819-42F3-8C9D-114AE2C043BF}&sc_site=eurobankequities&sc_params=${base64}`;
                this.apiService.fetchLayoutService<any[]>(action,"")
                  .then(resp => {
                    if (resp.status === 200) {
                      debugger;
                      var response = (resp.data as any).sitecore.route.placeholders["jss-main"].filter((x:any )=> x?.componentName == "ComplaintForm")[0];
                      if(response?.fields?.result?.apiSuccess){
                        this.submissionResponse = "success";
                      }else{
                        this.submissionResponse = "fail";
                      }
                      this.loading = false;
                      this.clearForm();
                      setTimeout(() => {
                        document.getElementById("complaintSumbitMessage").scrollIntoView({block:'center'});
                      }, 5);
                    }
                    else{
                      this.loading = false;
                      this.submissionResponse = "fail";
                      setTimeout(() => {
                        document.getElementById("complaintSumbitMessage").scrollIntoView({block:'center'});
                      }, 5);
                    }
                  });
              }else{
                this.submissionResponse = "fail";
                this.loading = false;
              }
            },
            error: (err) => {
              console.error('API error:', err);
              this.submissionResponse = "fail";
              this.loading = false;
              setTimeout(() => {
                document.getElementById("complaintSumbitMessage").scrollIntoView({block:'center'});
              }, 5);
            }
          });
          
        });      
    }
  }

  ngOnDestroy(): void {
    if (this.reCaptchaSubscription) {
        this.reCaptchaSubscription.unsubscribe();
    }
  }
}
